function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { colorToHsl, getHslAnimationFromHsl } from "../../Utils/ColorUtils";
import { itemFromArray } from "../../Utils/Utils";
import { randomInRange } from "../../Utils/NumberUtils";

function updateColorValue(delta, value, valueAnimation, max, decrease) {
  var _a;

  var colorValue = value;

  if (!colorValue || !colorValue.enable) {
    return;
  }

  var offset = randomInRange(valueAnimation.offset);
  var velocity = ((_a = value.velocity) !== null && _a !== void 0 ? _a : 0) * delta.factor + offset * 3.6;

  if (!decrease || colorValue.status === 0) {
    colorValue.value += velocity;

    if (decrease && colorValue.value > max) {
      colorValue.status = 1;
      colorValue.value -= colorValue.value % max;
    }
  } else {
    colorValue.value -= velocity;

    if (colorValue.value < 0) {
      colorValue.status = 0;
      colorValue.value += colorValue.value;
    }
  }

  if (colorValue.value > max) {
    colorValue.value %= max;
  }
}

function updateStrokeColor(particle, delta) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;

  if (!((_a = particle.stroke) === null || _a === void 0 ? void 0 : _a.color)) {
    return;
  }

  var animationOptions = particle.stroke.color.animation;
  var h = (_c = (_b = particle.strokeColor) === null || _b === void 0 ? void 0 : _b.h) !== null && _c !== void 0 ? _c : (_d = particle.color) === null || _d === void 0 ? void 0 : _d.h;

  if (h) {
    updateColorValue(delta, h, animationOptions.h, 360, false);
  }

  var s = (_f = (_e = particle.strokeColor) === null || _e === void 0 ? void 0 : _e.s) !== null && _f !== void 0 ? _f : (_g = particle.color) === null || _g === void 0 ? void 0 : _g.s;

  if (s) {
    updateColorValue(delta, s, animationOptions.s, 100, true);
  }

  var l = (_j = (_h = particle.strokeColor) === null || _h === void 0 ? void 0 : _h.l) !== null && _j !== void 0 ? _j : (_k = particle.color) === null || _k === void 0 ? void 0 : _k.l;

  if (l) {
    updateColorValue(delta, l, animationOptions.l, 100, true);
  }
}

export var StrokeColorUpdater = /*#__PURE__*/function () {
  function StrokeColorUpdater(container) {
    _classCallCheck(this, StrokeColorUpdater);

    this.container = container;
  }

  _createClass(StrokeColorUpdater, [{
    key: "init",
    value: function init(particle) {
      var _a, _b;

      var container = this.container;
      particle.stroke = particle.options.stroke instanceof Array ? itemFromArray(particle.options.stroke, particle.id, particle.options.reduceDuplicates) : particle.options.stroke;
      particle.strokeWidth = particle.stroke.width * container.retina.pixelRatio;
      var strokeHslColor = (_a = colorToHsl(particle.stroke.color)) !== null && _a !== void 0 ? _a : particle.getFillColor();

      if (strokeHslColor) {
        particle.strokeColor = getHslAnimationFromHsl(strokeHslColor, (_b = particle.stroke.color) === null || _b === void 0 ? void 0 : _b.animation, container.retina.reduceFactor);
      }
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _a, _b, _c, _d;

      var color = (_a = particle.stroke) === null || _a === void 0 ? void 0 : _a.color;
      return !particle.destroyed && !particle.spawning && !!color && (((_b = particle.strokeColor) === null || _b === void 0 ? void 0 : _b.h.value) !== undefined && color.animation.h.enable || ((_c = particle.strokeColor) === null || _c === void 0 ? void 0 : _c.s.value) !== undefined && color.animation.s.enable || ((_d = particle.strokeColor) === null || _d === void 0 ? void 0 : _d.l.value) !== undefined && color.animation.l.enable);
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateStrokeColor(particle, delta);
    }
  }]);

  return StrokeColorUpdater;
}();